import { render, staticRenderFns } from "./ModalAlertComponent.vue?vue&type=template&id=546d77a9&scoped=true&"
import script from "./ModalAlertComponent.vue?vue&type=script&lang=js&"
export * from "./ModalAlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertComponent.vue?vue&type=style&index=0&id=546d77a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d77a9",
  null
  
)

export default component.exports